import { useLocation, useNavigate } from "react-router-dom";

export const lenisStore = { instance: null };

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisStore.instance) {
    lenisStore.instance.scrollTo(el, { offset: -72, duration: 1.6 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const useSectionNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  return (id) => {
    if (location.pathname === "/") scrollToSection(id);
    else navigate(`/#${id}`);
  };
};
